import React from 'react';
import { forwardRef } from '@/internals/utils';
import { useStyles } from '@/internals/hooks';
import type { WithAsProps } from '@/internals/types';

export interface FlexboxGridItemProps extends WithAsProps {
  /**
   * The number of columns the item should span
   * @deprecated Please use `<Col span={...}>` instead.
   */
  colspan?: number;

  /**
   * The order of the item in the grid
   * @deprecated Please use `<Col order={...}>` instead.
   */
  order?: number;
}

/**
 * The `FlexboxGrid.Item` component is used to specify the layout of the child element in the `FlexboxGrid` component.
 * @see https://rsuitejs.com/components/flexbox-grid
 * @deprecated Please use `Col` instead.
 */
const FlexboxGridItem = forwardRef<'div', FlexboxGridItemProps>(
  (props: FlexboxGridItemProps, ref) => {
    const {
      as: Component = 'div',
      className,
      classPrefix = 'flex-box-grid-item',
      colspan = 0,
      order = 0,
      ...rest
    } = props;

    const { merge, withPrefix } = useStyles(classPrefix);
    const classes = merge(
      className,
      withPrefix({
        [colspan]: colspan > 0,
        [`order-${order}`]: order
      })
    );

    return <Component ref={ref} {...rest} className={classes} />;
  }
);

FlexboxGridItem.displayName = 'FlexboxGridItem';

export default FlexboxGridItem;
